import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";
import timestampToDate from "../../tools/timestampToDate";
import Tooltip from "@material-ui/core/Tooltip";
import AckShippingModal from "../modals/AckShippingModal";
import ProductOrdersModal from "../modals/ProductOrdersModal";
import { connect } from "react-redux";
import TotalCostColumn from "./TotalCostColumn";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

function PaidOrdersTable(props) {
  const classes = useStyles();

  const orders = props.orders.filter((order) => order.status === "paid");

  const [orderId, setOrderId] = React.useState(1);

  const [productModalOpen, setProductModalOpen] = React.useState(false);
  const toggleProductModalOpen = (orderId) => {
    if (!isNaN(orderId)) setOrderId(orderId);
    setProductModalOpen(!productModalOpen);
  };

  const [open, setOpen] = React.useState(false);
  const toggleOpen = (orderId) => {
    if (!isNaN(orderId)) setOrderId(orderId);
    setOpen(!open);
  };

  const getOrderFromId = () => {
    let filteredOrders = orders.filter((order) => order.id === orderId);
    return filteredOrders.length === 0 ? [] : filteredOrders[0];
  };

  return (
    <div>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Order #</TableCell>
              <TableCell align="center">Total $</TableCell>
              <TableCell align="center">Created</TableCell>
              <TableCell align="center">Name</TableCell>
              <TableCell align="center">Address</TableCell>
              <TableCell align="center">Email</TableCell>
              <TableCell align="center">Items</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((row) => (
              <TableRow key={row.id}>
                <TableCell align="center">{row.id}</TableCell>
                <TableCell align="center">
                  <TotalCostColumn item={row} />
                </TableCell>
                <TableCell align="center">
                  {timestampToDate(row.created_at).toLocaleString()}
                </TableCell>
                <TableCell align="center">
                  {row.first_name} {row.last_name}
                </TableCell>
                <TableCell align="center">
                  {row.street_address}, {row.town_city}, {row.province}
                  {row.postal_code}
                </TableCell>
                <TableCell align="center">{row.email}</TableCell>
                <TableCell align="center">
                  <Tooltip title="View items" placement="top-start">
                    <Button
                      variant={"contained"}
                      color={"secondary"}
                      size={"small"}
                      disableElevation
                      onClick={() => toggleProductModalOpen(row.id)}
                    >
                      View {row.products.length} items
                    </Button>
                  </Tooltip>
                </TableCell>
                <TableCell align="center">
                  <Tooltip title={"Ack shipping"} placement={"top-start"}>
                    <Button
                      variant={"contained"}
                      color={"primary"}
                      size={"small"}
                      disableElevation
                      onClick={() => toggleOpen(row.id)}
                    >
                      ACK
                    </Button>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ProductOrdersModal
        productOrders={getOrderFromId().products}
        open={productModalOpen}
        handleClose={toggleProductModalOpen}
      />
      <AckShippingModal
        open={open}
        handleClose={toggleOpen}
        orderId={orderId}
      />
    </div>
  );
}

// Gets props from the redux store
const mapStateToProps = (state) => {
  return {
    orders: state.orders,
  };
};

export default connect(mapStateToProps)(PaidOrdersTable);



// WEBPACK FOOTER //
// ./src/components/tables/PaidOrdersTable.js